import { Tab } from "@headlessui/react";
import Link from "next/link";
import { useState } from "react";
import { TabNoData } from "../../components/common/NoData";

import TextNavBackground from "../../components/common/TextNavBackground";
import PlayerProfileCard, {
  LoanPlayerProfileCard,
} from "../../components/elements/players/PlayerProfileCard";

import { apiWrapper } from "../../utils/api/apiWrapper";
import { kKotokoPlayerListURL } from "../../utils/constants/apiUrls";
import {
  ATTACKER,
  DEFENDER,
  GOALKEEPER,
  MIDFIELDER,
} from "../../utils/constants/names";
import { ONE_HOUR_REFRESH_INTERVAL_SECONDS } from "../../utils/constants/numbers";
import { PLAYER_LIST_URL } from "../../utils/constants/websiteUrls";
import {
  customStaticSeoConfig,
  getApiToken,
} from "../../utils/helpers/helpers";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const PlayerList = ({ players }) => {
  let [kotokoPlayers] = useState({
    Men: players?.men,
    // Women: players?.women,
    Academy: players?.academy,
  });

  const menPlayers = kotokoPlayers.Men.filter((obj) => {
    return obj.player_status !== "On Loan";
  });

  const menLoanPlayers = kotokoPlayers.Men.filter((obj) => {
    return obj.player_status === "On Loan";
  });

  return (
    <>
      {customStaticSeoConfig("Asante Kotoko Players")}

      <TextNavBackground title={"Players"} />

      <div className="block w-full text-base sm:text-sm rounded-md">
        <Tab.Group>
          <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto bg-gray-200">
            {Object.keys(kotokoPlayers).map((group) => (
              <Tab
                key={group}
                className={({ selected }) =>
                  classNames(
                    "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                    selected
                      ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none",
                  )
                }
              >
                {group}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels className="mt-2 max-w-2xl mx-auto lg:max-w-7xl lg:px-8 px-6">
            {/** MEN TAB PANEL */}
            {kotokoPlayers.Men.length === 0 && (
              <Tab.Panel key="Men" className="pt-0 pb-10">
                <TabNoData />
              </Tab.Panel>
            )}

            {kotokoPlayers.Men.length !== 0 && (
              <Tab.Panel key="Men">
                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Goalkeepers
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {menPlayers.map(
                    (player) =>
                      player.player_position === GOALKEEPER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>

                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Defenders
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {menPlayers.map(
                    (player) =>
                      player.player_position === DEFENDER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>

                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Midfielders
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {menPlayers.map(
                    (player) =>
                      player.player_position === MIDFIELDER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>

                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Attackers
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {menPlayers.map(
                    (player) =>
                      player.player_position === ATTACKER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>

                {menLoanPlayers.length === 0 ? (
                  <Tab.Panel key="Men" className="pt-0 pb-10">
                    <TabNoData />
                  </Tab.Panel>
                ) : (
                  <>
                    <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                      On Loan
                    </h2>
                    <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                      {menLoanPlayers.map((player) => (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <LoanPlayerProfileCard player={player} />
                        </Link>
                      ))}
                    </div>
                  </>
                )}
              </Tab.Panel>
            )}

            {/** WOMEN TAB PANEL */}
            {/* {kotokoPlayers.Women.length === 0 && (
            <Tab.Panel key="Women" className="pt-0 pb-10">
              <TabNoData />
            </Tab.Panel>
          )} */}

            {/* {kotokoPlayers.Women.length !== 0 && (
            <Tab.Panel key="Women">
              <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                Goalkeepers
              </h2>
              <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                {kotokoPlayers.Women.map(
                  (player) =>
                    player.player_position === GOALKEEPER && (
                      (<Link
                        key={player.id}
                        href={`${PLAYER_LIST_URL}/${player.slug}`}
                        className="group">

                        <PlayerProfileCard player={player} />

                      </Link>)
                    )
                )}
              </div>

              <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                Defenders
              </h2>
              <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                {kotokoPlayers.Women.map(
                  (player) =>
                    player.player_position === DEFENDER && (
                      (<Link
                        key={player.id}
                        href={`${PLAYER_LIST_URL}/${player.slug}`}
                        className="group">

                        <PlayerProfileCard player={player} />

                      </Link>)
                    )
                )}
              </div>

              <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                Midfielders
              </h2>
              <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                {kotokoPlayers.Women.map(
                  (player) =>
                    player.player_position === MIDFIELDER && (
                      (<Link
                        key={player.id}
                        href={`${PLAYER_LIST_URL}/${player.slug}`}
                        className="group">

                        <PlayerProfileCard player={player} />

                      </Link>)
                    )
                )}
              </div>

              <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                Attackers
              </h2>
              <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                {kotokoPlayers.Women.map(
                  (player) =>
                    player.player_position === ATTACKER && (
                      (<Link
                        key={player.id}
                        href={`${PLAYER_LIST_URL}/${player.slug}`}
                        className="group">

                        <PlayerProfileCard player={player} />

                      </Link>)
                    )
                )}
              </div>
            </Tab.Panel>
          )} */}

            {/** ACADEMY TAB PANEL */}
            {kotokoPlayers.Academy.length === 0 && (
              <Tab.Panel key="Academy" className="pt-0 pb-10">
                <TabNoData />
              </Tab.Panel>
            )}

            {kotokoPlayers.Academy.length !== 0 && (
              <Tab.Panel key="Academy">
                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Goalkeepers
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {kotokoPlayers.Academy.map(
                    (player) =>
                      player.player_position === GOALKEEPER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>

                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Defenders
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {kotokoPlayers.Academy.map(
                    (player) =>
                      player.player_position === DEFENDER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          s
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>

                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Midfielders
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {kotokoPlayers.Academy.map(
                    (player) =>
                      player.player_position === MIDFIELDER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>

                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Attackers
                </h2>
                <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
                  {kotokoPlayers.Academy.map(
                    (player) =>
                      player.player_position === ATTACKER && (
                        <Link
                          key={player.id}
                          href={`${PLAYER_LIST_URL}/${player.slug}`}
                          className="group"
                        >
                          <PlayerProfileCard player={player} />
                        </Link>
                      ),
                  )}
                </div>
              </Tab.Panel>
            )}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
};

export default PlayerList;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const players = await apiWrapper.get(kKotokoPlayerListURL, token);

  return {
    props: {
      players: players?.data,
    },
    revalidate: ONE_HOUR_REFRESH_INTERVAL_SECONDS,
  };
};
